import { useEffect, useState } from "react";
import "../../Css/Home/HomeMainVendors.css";
import VendorCard from "../VendorCard";
import SectionComp from "../SectionComp";
import { get } from "../../services/ApiRouting";
const HomeMainVendors = ({ title, desc, type, bg }) => {
  const [vendorData, setVendorData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchVendor = async () => {
    try {
      setLoading(true);
      const response = await get(
        `vendors?limit=6&page=1${type !== "all" ? `&category=${type}` : ""}`
      );
      setVendorData(response?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchVendor();
    }, 1000);
    return () => clearTimeout(dbounce);
  }, []);

  return (
    <section
      className={`section home-main-vendor-section section ${
        bg && "section section-bg"
      }`}
    >
      <div className="container">
        <div className="home-main-vendor-section-con">
          <SectionComp title={title} para={desc} />

          <div className="home-mainvendor-section-details-main-con">
            <div className="row">
              {vendorData?.map((elem) => {
                const { cover_image, name, based_area, city, pricing, slug } =
                  elem;
                return (
                  <>
                    <div className="col-lg-4 col-md-6">
                      <VendorCard
                        loading={loading}
                        cover_image={cover_image}
                        name={name}
                        based_area={based_area}
                        city={city}
                        pricing={pricing}
                        slug={slug}
                      />
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeMainVendors;
